import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/services/api/api.service';
import { LoadingService } from 'src/app/services/loading.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-edit-endurance',
  templateUrl: './edit-endurance.component.html',
  styleUrls: ['./edit-endurance.component.scss'],
  standalone: false
})
export class EditEnduranceComponent implements OnInit {
  editDayForm: FormGroup;
  @Input() data: any;
  @Input() info: any;
  dcReasons: any;
  today: string = new Date().toISOString().split('T')[0];
  constructor(
    private modal: ModalController,
    private loadingService: LoadingService,
    private toastService: ToastService,
    private apiService:ApiService
  ) {}

  ngOnInit() {
    this.editDayForm = new FormGroup<any>({
      //dwell_date: new FormControl(null, Validators.required),
      id: new FormControl(null, Validators.required),
      monitoring_date: new FormControl(null, Validators.required),
      securement: new FormControl(null),
      completed_therapy: new FormControl(false),
      dc_reason: new FormControl(null),
      // blood_return: new FormControl(null, Validators.required),
      flushes_dropdown: new FormControl(null),
      clamped: new FormControl(null),
      notes: new FormControl(null),
      // responsibility: new FormControl(false),
      dressing_intact: new FormControl(false),
      blood_return: new FormControl(false),
    });
    this.getReasons();
    // Strip ISO time/zone so the native <input type="date"> renders the stored
    // calendar day, not the local-TZ conversion of UTC midnight.
    if (this.data?.monitoring_date) {
      this.data.monitoring_date = String(this.data.monitoring_date).split('T')[0];
    }
    this.editDayForm.patchValue(this.data)
  }
  closeModal() {
    this.editDayForm.reset();
    this.modal.dismiss('cancelled');
  }
  async submit() {
    console.log(this.info);
    await this.loadingService.presentLoading('');
    this.editDayForm.value.insertion_id = this.info.id;
    this.editDayForm.value.product_id = this.info.product_id;
    this.editDayForm.value.hospital_id = this.info.hospital_id;
    console.log(this.editDayForm);
    this.apiService
      .post('insertion_lifecycle/update', this.editDayForm.value)
      .subscribe(
        async (res) => {
          await this.loadingService.dismissLoader();
          this.toastService.presentSuccessToast(res.message);
          this.editDayForm.reset();
          await this.loadingService.dismissLoader();
          this.modal.dismiss('submitted');
        },
        async (error) => {
          await this.loadingService.dismissLoader();
          this.toastService.presentErrorToast(error.error.message);
        }
      );
  }
  getReasons(){
    this.apiService.get(`products_insertion/getDCList/2`).subscribe(res=>{
      this.dcReasons=res.data;
    })
  }
}
